import { SubmenuHandlers } from "../SubmenuHandlers";
import { ObjectBuilder, Image3D, ImgButton, LayoutUtils, Rectangle3D } from "@dreamcam/babylon-tools";
import { Env } from "../../../settings/Env";
import { StackPanel } from "@babylonjs/gui/2D/controls/stackPanel.js";
import { Control } from "@babylonjs/gui/2D/controls/control.js";
import { text } from "../../../TextResources";
export class SubmenuClientProfile {
    constructor(mesh, callbacks) {
        this._callbacks = callbacks;
        this.submenuHandlers = new SubmenuHandlers(mesh);
        this.submenuHandlers.hideSubmenuInstantly();
        const menu = Env.broadcast.menu;
        const cli = menu.user.submenus.clientProfile;
        const onPointerEnterHandler = () => {
            this.submenuHandlers.hideSubmenuCancel();
        };
        const onPointerOutHandler = () => {
            this.submenuHandlers.hideSubmenuStart(SubmenuHandlers.shortLifetime);
        };
        const root = new Rectangle3D("clientProfileRoot");
        root.thickness = mesh.m2px(cli.thickness);
        root.color = cli.outlineColor;
        root.useArc = true;
        root.background = menu.backgroundColor;
        root.cornerRadius = mesh.m2px(menu.cornerRadius);
        root.onPointerEnterObservable.add(onPointerEnterHandler);
        root.onPointerOutObservable.add(onPointerOutHandler);
        mesh.texture.addControl(root);
        const stackPanel = new StackPanel("clientProfileSubmenu");
        stackPanel.isHitTestVisible = false;
        stackPanel.isVertical = true;
        stackPanel.widthInPixels = mesh.m2px(cli.width);
        root.addControl(stackPanel);
        const signOutItem = new ImgButton("signOutItem", LayoutUtils.GetButtonLayout(cli.item.colorLayout, mesh));
        signOutItem.widthInPixels = mesh.m2px(cli.item.width);
        signOutItem.heightInPixels = mesh.m2px(cli.item.height);
        signOutItem.onPointerEnterObservable.add(onPointerEnterHandler);
        signOutItem.onPointerOutObservable.add(onPointerOutHandler);
        signOutItem.onClickObserver.add(this._callbacks.signout);
        stackPanel.addControl(signOutItem);
        const signOutImage = new Image3D("signOutImage", cli.signOutItem.image.src);
        signOutImage.isHitTestVisible = false;
        signOutImage.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        signOutImage.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        signOutImage.widthInPixels = mesh.m2px(cli.signOutItem.image.width);
        signOutImage.heightInPixels = mesh.m2px(cli.signOutItem.image.height);
        signOutImage.leftInPixels = mesh.m2px(cli.signOutItem.image.left);
        signOutImage.topInPixels = mesh.m2px(cli.signOutItem.image.top);
        signOutItem.addControl(signOutImage);
        const signOutText = ObjectBuilder.createTextBlock3D(mesh, "signOutText", text.lobby_userPanel_signout, cli.item.text);
        signOutText.isHitTestVisible = false;
        signOutItem.addControl(signOutText);
    }
}
